import { useMemo } from 'react';

export const useBranchesFormFields = () => {
    return useMemo(
        () => [
            // Row 1: Name (Half width)
            {
                name: 'name',
                label: 'Branch Name',
                type: 'text' as const,
                required: true,
                placeholder: 'Enter branch name',
                layout: { span: 24 },
                props: {
                    size: 'large',
                    maxLength: 30,
                },
                tooltip: 'Enter the name of the branch',
            },
        ],
        []
    );
}; 